<template>
  <v-card class="mx-auto my-12" max-width="374">

    <v-img src="/img/logo-a.png"></v-img>

    <v-card-title>{{ performance.location }}</v-card-title>
    <v-card-title>10 Years Later!</v-card-title>
    <v-card-title>(Where are they now??)</v-card-title>

    <v-card-actions>
      <v-btn color="deep-purple lighten-2" to="/cast">
        Vote
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Api from '@/services/Api'

export default {
  data() {
    return {
      performance: {},
    }
  },

  created() {
    this.getPerformance()
  },

  methods: {
    async getPerformance() {
      const response = await Api().get('get_performance')

      this.performance = response.data[0]
      console.log(this.performance)
    },

    reserve() {},
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
